import { useRegistrationStore } from '../../hooks';
import { EnvironmentHeaderView } from '../../components/EnvironmentHeaderView';

export const EnvironmentHeader = () => {
  const { onOpenModal } = useRegistrationStore();

  return <EnvironmentHeaderView handleClickRegistration={onOpenModal} />;
};
